"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetryProperty = exports.TelemetryEvents = void 0;
var TelemetryEvents;
(function (TelemetryEvents) {
    TelemetryEvents["Generate"] = "generate";
    TelemetryEvents["EnsureYoStart"] = "ensure-yo-start";
    TelemetryEvents["EnsureYo"] = "ensure-yo";
    TelemetryEvents["EnsureLatestYoStart"] = "ensure-latest-yo-start";
    TelemetryEvents["EnsureLatestYo"] = "ensure-latest-yo";
    TelemetryEvents["EnsureSharepointGeneratorStart"] = "ensure-sharepoint-generator-start";
    TelemetryEvents["EnsureSharepointGenerator"] = "ensure-sharepoint-generator";
    TelemetryEvents["EnsureLatestSharepointGeneratorStart"] = "ensure-latest-sharepoint-start";
    TelemetryEvents["EnsureLatestSharepointGenerator"] = "ensure-latest-sharepoint";
    TelemetryEvents["UseNotRecommendedVersion"] = "use-not-recommended-spfx-version";
})(TelemetryEvents = exports.TelemetryEvents || (exports.TelemetryEvents = {}));
var TelemetryProperty;
(function (TelemetryProperty) {
    TelemetryProperty["EnsureYoReason"] = "ensure-yo-reason";
    TelemetryProperty["EnsureSharepointGeneratorReason"] = "ensure-sharepoint-generator-reason";
    TelemetryProperty["EnsureLatestYoReason"] = "ensure-latest-yo-reason";
    TelemetryProperty["EnsureLatestSharepointGeneratorReason"] = "ensure-latest-sharepoint-generator-reason";
    TelemetryProperty["SPFxSolution"] = "spfx-solution";
})(TelemetryProperty = exports.TelemetryProperty || (exports.TelemetryProperty = {}));
//# sourceMappingURL=telemetryEvents.js.map